import { render } from "./users-card.vue?vue&type=template&id=92257bfa"
import script from "./users-card.vue?vue&type=script&setup=true&lang=js"
export * from "./users-card.vue?vue&type=script&setup=true&lang=js"

import "./users-card.vue?vue&type=style&index=0&id=92257bfa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/users-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "92257bfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92257bfa', __exports__)) {
    api.reload('92257bfa', __exports__)
  }
  
  module.hot.accept("./users-card.vue?vue&type=template&id=92257bfa", () => {
    api.rerender('92257bfa', render)
  })

}


export default __exports__